<div
  class="row"
  *ngFor="let newColor of newColors">
  <div class="col-12 col-md-12 col-lg-12 col-xl-2 mb-3 mb-md-3 mb-lg-3 mb-xl-0 color-group-name">{{ newColor.name }}</div>
  <div class="col-12 col-md-10">
    <div class="d-flex flex-wrap">
      <div
        class="color-box mb-3"
        *ngFor="let subColor of newColor.subColors"
        [class.color-box-border]="subColor.border"
        [ngStyle]="{ 'background-color': subColor.color }">
        {{ subColor.name }}
      </div>
    </div>
  </div>
</div>
